import { FC } from 'react'
import { KudosType } from '../../../types'
import { IconIndicator } from '../../../components/custom_components/IconIndicator/IconIndicator'
import { getKudosIcon, getKudosColor } from '../../../shared/kudosUtil'

export interface KudosIconIndicatorProps {
  kudosType: KudosType
  showTooltip?: boolean
}

export const KudosIconIndicator: FC<KudosIconIndicatorProps> = ({ kudosType }) => {
  return <IconIndicator icon={getKudosIcon(kudosType)} background={getKudosColor(kudosType)} iconSize={15} size="l" />
}
